'use client';

import { type IDefaultFormBuilderProps } from '@/components/Form/Fields/types';
import Label from '@/components/Label/Label';
import InfoIconModal from '@/components/infoIcon/InfoIconModal';
import { RichText } from '@/components/richText/RichText';
import { TextField } from '@/components/textField';
import { hasContent } from '@/helper/RichText';
import type { FormTextareaStoryblok } from '@/types/component-types-sb';
import { type FC } from 'react';

interface FormTextAreaProps extends FormTextareaStoryblok, IDefaultFormBuilderProps {}

const FormTextArea: FC<FormTextAreaProps> = ({
  field,
  id,
  label,
  placeholder,
  infoText,
  errorMessage,
  isInvalid,
  disabled,
  required,
  readOnly,
}) => {
  return (
    <TextField
      {...field}
      required={required}
      id={id}
      disabled={disabled}
      placeholder={placeholder}
      label={label && <Label text={label} />}
      helperText={isInvalid && errorMessage}
      error={isInvalid}
      fullWidth
      InputProps={{
        endAdornment: hasContent(infoText) ? (
          <InfoIconModal trackingLabel={label ?? field.name}>
            <RichText text={infoText} />
          </InfoIconModal>
        ) : undefined,
        readOnly,
        inputProps: {
          tabIndex: readOnly ? -1 : 0,
        },
      }}
      inputProps={{ 'data-testid': 'form-builder-text-area' }}
      multiline
      rows={5}
    />
  );
};

export default FormTextArea;
